import { createSlice } from '@reduxjs/toolkit';

import { clear } from './onboarding_responses';

export interface OnboardingStepState {
  currentStep: number;
}

// REDUCER
export const initialOnboardingState: OnboardingStepState = {
  currentStep: 0,
};

const calculatePreviousStep = (currentStep) => {
  return currentStep > 0 ? currentStep - 1 : 0;
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: initialOnboardingState,
  reducers: {
    goToNextOnboardingStep: (state) => {
      state.currentStep += 1;
    },
    goToPreviousOnboardingStep: (state) => {
      state.currentStep = calculatePreviousStep(state.currentStep);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clear, () => ({
      currentStep: 0,
    }));
  },
});

export const { goToNextOnboardingStep, goToPreviousOnboardingStep } =
  onboardingSlice.actions;

export default onboardingSlice.reducer;
